import { watch } from "vue";
import { debounce } from "@sazka/utils/debounce";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { documentReady } from "@sazka/utils/document-ready";

const isSm = useBreakpoints("sm");

const FIXED_OFFSET = 16;
let menu: HTMLElement = null;
let menuPosition: number;
const isJackpotsPage = document.body.classList.contains("theme-games--jackpots");

function secondaryMenuSticky(isInitialLoad = false) {
    menu = document.querySelector<HTMLElement>(".ds-secondary-menu--sticky");

    if (!menu) return;

    menuPosition = window.scrollY + menu.getBoundingClientRect().top;

    if (!isInitialLoad) {
        removeMenuFixedState();
    }

    if (isInitialLoad) {
        window.addEventListener(
            "scroll",
            debounce(() => handleScroll(), 10)
        );
    }

    handleScroll();
}

function getHeaderOffset() {
    return `${FIXED_OFFSET}px`;
}

function removeMenuFixedState() {
    menu.style.position = null;
    menu.style.transform = `translateY(0)`;
    menu.classList.remove("ds-secondary-menu--fixed");
    document.body.classList.remove("secondary-menu-active");
}

function handleScroll() {
    if (!isSm.value || isJackpotsPage) {
        removeMenuFixedState();
        return;
    }

    const scrollTop = window.scrollY;

    if (scrollTop > menuPosition - FIXED_OFFSET) {
        menu.style.position = "fixed";
        menu.style.transform = `translateY(${getHeaderOffset()})`;
        menu.classList.add("ds-secondary-menu--fixed");
        document.body.classList.add("secondary-menu-active");
    } else {
        removeMenuFixedState();
    }
}

watch(isSm, () => {
    secondaryMenuSticky();
});

documentReady(() => secondaryMenuSticky(true));
